import {createContext} from 'react'

const CatProductosContext = createContext()

export default CatProductosContext